var _circle, _circle2, _circle3, _circle4, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerifiedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.25,
    fill: "#ECF5F8",
    stroke: "#4097AD",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7.5,
    fill: "#F8D7C8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6.5,
    fill: "#F1AF90"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5.5,
    fill: "#E87A46"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2623 14.3216L9.36066 14.1307C9.27869 14.1148 9.21311 14.0737 9.16393 14.0073C9.11475 13.9412 9.09563 13.8684 9.10656 13.7889L9.19672 12.8905L8.58197 12.2067C8.52732 12.1484 8.5 12.0795 8.5 12C8.5 11.9205 8.52732 11.8516 8.58197 11.7933L9.19672 11.1095L9.10656 10.2111C9.09563 10.1316 9.11475 10.0588 9.16393 9.99265C9.21311 9.92629 9.27869 9.88516 9.36066 9.86926L10.2623 9.67845L10.7377 8.89929C10.7814 8.83039 10.8415 8.78534 10.918 8.76413C10.9945 8.74293 11.071 8.74558 11.1475 8.77208L12 9.12191L12.8525 8.77208C12.929 8.74558 13.0055 8.74293 13.082 8.76413C13.1585 8.78534 13.2186 8.83039 13.2623 8.89929L13.7377 9.67845L14.6393 9.86926C14.7213 9.88516 14.7869 9.92629 14.8361 9.99265C14.8852 10.0588 14.9044 10.1316 14.8934 10.2111L14.8033 11.1095L15.418 11.7933C15.4727 11.8516 15.5 11.9205 15.5 12C15.5 12.0795 15.4727 12.1484 15.418 12.2067L14.8033 12.8905L14.8934 13.7889C14.9044 13.8684 14.8852 13.9412 14.8361 14.0073C14.7869 14.0737 14.7213 14.1148 14.6393 14.1307L13.7377 14.3216L13.2623 15.1007C13.2186 15.1696 13.1585 15.2147 13.082 15.2359C13.0055 15.2571 12.929 15.2544 12.8525 15.2279L12 14.8781L11.1475 15.2279C11.071 15.2544 10.9945 15.2571 10.918 15.2359C10.8415 15.2147 10.7814 15.1696 10.7377 15.1007L10.2623 14.3216ZM11.4262 12.9064C11.4863 12.9647 11.5628 12.9938 11.6557 12.9938C11.7486 12.9938 11.8251 12.9647 11.8852 12.9064L13.2787 11.5548C13.3443 11.4912 13.377 11.4156 13.377 11.328C13.377 11.2407 13.3443 11.1652 13.2787 11.1016C13.2131 11.038 13.1353 11.0062 13.0452 11.0062C12.955 11.0062 12.877 11.038 12.8115 11.1016L11.6557 12.2226L11.1803 11.7694C11.1148 11.7111 11.0369 11.6833 10.9469 11.6858C10.8566 11.6886 10.7814 11.7191 10.7213 11.7774C10.6612 11.8357 10.6311 11.9099 10.6311 12C10.6311 12.0901 10.6612 12.1643 10.7213 12.2226L11.4262 12.9064Z",
    fill: "#ECF5F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/VerifiedIcon.1299077ca6485a50cfcbcb513e3d116c.svg";
export { ForwardRef as ReactComponent };